module.exports = __webpack_public_path__ + "static/tagulan-main-promo-page-6733773fbc93e65920f25058efd86020.jpg";